import React, { useState } from "react";
import { JobType } from "../../Constants/Enums/teachers.enum";
import { SectionHeader } from "../Header/SectionHeader";
import InputField, { InputType } from "../input/inputField";
import Dropdown from "../Dropdown/dropdown";
import { GENDER_OPTIONS } from "../../Constants/options/gender.options";
import { getSelectedOptionFromValue } from "../../Helper/options.helper";
import { useGetSchoolBranchesOptions } from "../../hooks/branchHooks/branch.hooks";
import { useGetClassesOptions } from "../../hooks/classHooks/class.hooks";
import { useGetSchoolBlocksOptions } from "../../hooks/schoolBlockHooks/block.hooks";
import { DropdownOptions } from "../dropdownOptions";
import { MultiSelectDropdown } from "../Dropdown/MultiSelectDropdown";
import { useSubjectByClassIdOptions } from "../../hooks/subjectHooks/subject.hooks";
import { JOB_TYPE_OPTIONS } from "../../Constants/options/jobType.options";
import { ParentAccountDetails } from "../parents/ParentAccountDetails";
import { BtnSize, BtnType, Button } from "../Button";
import { useDispatch } from "react-redux";
import { setWarningMessage } from "../../Redux/Slices/alert.slice";
import TeachersMessage from "../../Constants/Message/Teacher.messages";

interface Props {
  firstName: string;
  onSetFirstName: (firstName: string) => unknown;
  middleName: string;
  onSetMiddleName: (middleName: string) => unknown;
  lastName: string;
  onSetLastName: (lastName: string) => unknown;
  email: string;
  onSetEmail: (email: string) => unknown;
  password: string;
  onSetPassword: (password: string) => unknown;
  mobile: string;
  onSetMobile: (mobile: string) => unknown;
  address: string;
  onSetAddress: (address: string) => unknown;
  gender: string;
  onSetGender: (gender: string) => unknown;
  classId: number;
  onSetClassId: (classId: number) => unknown;
  schoolBranchId: number;
  onSetSchoolBranchId: (branchId: number) => unknown;
  schoolBlockId: number;
  onSetSchoolBlockId: (blockId: number) => unknown;
  subjects: [];
  onSetSubjects: (subjects: []) => unknown;
  jobType: JobType;
  onSetJobType: (jobType: JobType) => unknown;
  baseSalary: null | string;
  onSetBaseSalary: (baseSalary: string | number) => unknown;
  onReset: () => unknown;
  onSubmit: () => unknown;
  isSubmitting: boolean;
  submitText?: string;
  isUpdating?: boolean;
}
export const TeachersForm = ({
  firstName,
  middleName,
  lastName,
  email,
  password,
  mobile,
  address,
  gender,
  classId,
  schoolBranchId,
  schoolBlockId,
  subjects,
  jobType,
  baseSalary,
  submitText = "Register",

  onSetFirstName,
  onSetMiddleName,
  onSetLastName,
  onSetPassword,
  onSetEmail,
  onSetMobile,
  onSetAddress,
  onSetGender,
  onSetClassId,
  onSetSchoolBranchId,
  onSetSchoolBlockId,
  onSetSubjects,
  onSetJobType,
  onSetBaseSalary,
  onReset,
  onSubmit,
  isSubmitting,
  isUpdating = false,
}: Props) => {
  const dispatch = useDispatch();

  const { data: BRANCHES_OPTIONS } = useGetSchoolBranchesOptions();

  const { data: CLASSES_OPTIONS } = useGetClassesOptions();

  const { data: BLOCKS_OPTIONS } = useGetSchoolBlocksOptions();

  const { data: SUBJECTS_OPTIONS } = useSubjectByClassIdOptions({ classId });

  const [subjectErrMess, setSubjectErrMess] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSetSubjects = (options: DropdownOptions[]) => {
    onSetSubjects(options as []);
  };

  const validatePayload = () => {
    if (!firstName) {
      dispatch(setWarningMessage(TeachersMessage.FIRST_NAME_REQUIRED));
      return false;
    }
    if (!lastName) {
      dispatch(setWarningMessage(TeachersMessage.LAST_NAME_REQUIRED));
      return false;
    }
    if (!gender) {
      dispatch(setWarningMessage(TeachersMessage.GENDER_REQUIRED));
      return false;
    }
    if (!email) {
      dispatch(setWarningMessage(TeachersMessage.EMAIL_REQUIRED));
      return false;
    }
    if (!address) {
      dispatch(setWarningMessage(TeachersMessage.ADDRESS_REQUIRED));
      return false;
    }
    if (!mobile) {
      dispatch(setWarningMessage(TeachersMessage.MOBILE_REQUIRED));
      return false;
    }
    if (!password && !isUpdating) {
      dispatch(setWarningMessage(TeachersMessage.PASSWORD_REQUIRED));
      return false;
    }
    if (!confirmPassword && !isUpdating) {
      dispatch(setWarningMessage(TeachersMessage.CONFIRM_PASSWORD_REQUIRED));
      return false;
    }
    if (!classId) {
      dispatch(setWarningMessage(TeachersMessage.CONFIRM_PASSWORD_REQUIRED));
      return false;
    }
    if (!(subjects || []).length) {
      dispatch(setWarningMessage(TeachersMessage.SUBJECT_REQUIRED));
      return false;
    }
    if (!baseSalary) {
      dispatch(setWarningMessage(TeachersMessage.BASE_SALARY_REQUIRED));
      return false;
    }
    if (!schoolBranchId) {
      dispatch(setWarningMessage(TeachersMessage.SCHOOL_BRANCH_REQUIRED));
      return false;
    }
    if (!schoolBranchId) {
      dispatch(setWarningMessage(TeachersMessage.SCHOOL_BLOCK_REQUIRED));
      return false;
    }
    if (!jobType) {
      dispatch(setWarningMessage(TeachersMessage.JOB_TYPE_REQUIRED));
      return false;
    }
    if (password !== confirmPassword && !isUpdating) {
      dispatch(setWarningMessage(TeachersMessage.CONFIRM_PASSWORD_NO_MATCH));
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validatePayload()) return;
    onSubmit();
  };
  return (
    <>
      <SectionHeader headerText="General information" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8">
        <InputField
          value={firstName}
          setValue={(value) => {
            onSetFirstName(value);
          }}
          label="First name"
          isRequiredFocusonValidation
          name="register-teacher-first-name"
        />
        <InputField
          value={middleName}
          setValue={(value) => {
            onSetMiddleName(value);
          }}
          label="Midle name"
          isRequiredFocusonValidation
          name="register-teacher-middle-name"
        />
        <InputField
          value={lastName}
          setValue={(value) => {
            onSetLastName(value);
          }}
          label="Last name"
          isRequiredFocusonValidation
          name="register-teacher-last-name"
        />
        <InputField
          value={mobile}
          setValue={(value) => {
            onSetMobile(value);
          }}
          label="Mobile"
          isRequiredFocusonValidation
          name="register-teacher-mobile"
        />
        <InputField
          value={address}
          setValue={(value) => {
            onSetAddress(value);
          }}
          label="Address"
          isRequiredFocusonValidation
          name="register-teacher-address"
        />
        <Dropdown
          label="Gender *"
          options={GENDER_OPTIONS || []}
          selectedOption={getSelectedOptionFromValue(GENDER_OPTIONS, gender)}
          setSelectedOption={(option) => {
            onSetGender(option.value as string);
          }}
        />
      </div>

      <div className="mt-6" />
      <SectionHeader headerText="Program information" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8">
        <Dropdown
          label="Class"
          options={CLASSES_OPTIONS || []}
          selectedOption={
            (CLASSES_OPTIONS || []).find(
              ({ value }) => value === classId
            ) as DropdownOptions
          }
          setSelectedOption={(selectedOption: DropdownOptions) => {
            setSubjectErrMess("");
            onSetClassId(selectedOption.value as number);
          }}
        />
        <Dropdown
          label="School Branch"
          options={BRANCHES_OPTIONS || []}
          selectedOption={
            (BRANCHES_OPTIONS || []).find(
              ({ value }) => value === schoolBranchId
            ) as DropdownOptions
          }
          setSelectedOption={(selectedOption: DropdownOptions) => {
            onSetSchoolBranchId(selectedOption.value as number);
          }}
        />
        <Dropdown
          label="School Blocks"
          options={BLOCKS_OPTIONS || []}
          selectedOption={
            (BLOCKS_OPTIONS || []).find(
              ({ value }) => value === schoolBlockId
            ) as DropdownOptions
          }
          setSelectedOption={(selectedOption: DropdownOptions) => {
            onSetSchoolBlockId(selectedOption.value as number);
          }}
        />
      </div>

      <div className="" style={{ maxWidth: "450px" }}>
        <MultiSelectDropdown
          label="Subjects"
          allOptions={SUBJECTS_OPTIONS || []}
          selectedOptions={subjects}
          setOptions={handleSetSubjects}
          errorMessage={subjectErrMess}
          validationOnClick={() => {
            if (!classId) {
              setSubjectErrMess("Select class first");
              return false;
            }
            return true;
          }}
        />
      </div>

      <div className="mt-6" />
      <SectionHeader headerText="Employment specification" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8">
        <Dropdown
          label="Job type *"
          options={JOB_TYPE_OPTIONS || []}
          selectedOption={getSelectedOptionFromValue(JOB_TYPE_OPTIONS, jobType)}
          setSelectedOption={(option) => {
            onSetJobType(option.value as JobType);
          }}
        />
        <InputField
          value={baseSalary}
          setValue={(value) => {
            onSetBaseSalary(value);
          }}
          type={InputType.Number}
          label="Base salary"
          isRequiredFocusonValidation
          name="register-teacher-base-salary"
        />
      </div>

      <div className="mt-6" />
      <SectionHeader
        headerText="Account information"
        subText="Enter precise account details for parents during registration. This information will serve as their login credentials for secure access to the system."
      />
      <ParentAccountDetails
        email={email}
        password={password}
        confirmPassword={confirmPassword}
        onEmailChange={(email) => onSetEmail(email)}
        onPasswordChange={(password) => onSetPassword(password)}
        onConfirmPasswordChange={(confirmPassword) =>
          setConfirmPassword(confirmPassword)
        }
      />
      <div className="flex flex-col lg:flex-row md:flex-row gap-y-2 md:gap-y-0 lg:gap-y-0 gap-x-5 w-full mt-5">
        <Button
          text="Reset"
          loading={false}
          // btnSize={BtnSize.md}
          btnType={BtnType.basic}
          onClick={onReset}
          // onClick={() => {
          //   setConfirmPassword("");
          //   dispatch(reset());
          // }}
        />
        <Button
          text={submitText}
          btnSize={BtnSize.md}
          onClick={handleSubmit}
          requiresValidationOnSubmit
          loading={isSubmitting}
        />
      </div>
    </>
  );
};
